import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import sounds from 'src/lib/sounds';
import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import { Avatar } from '../components/shared/Avatar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { energyGiftConfirmation as ui } from '../gifts/PopupGiftsConfirmation.style';
import { AvatarFrameId } from 'src/replicant/profile/frames';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupVisitReferral extends PopupBasic<
  (canceled: boolean) => void
> {
  constructor(opts: { superview: View; close: (canceled: boolean) => void }) {
    super({
      superview: opts.superview,
      close: (canceled?: boolean) => opts.close(!!canceled),
      zIndex: 10000,
      width: uiConfig.popups.buruburu.width,
      height: 520,
      darkerBg: false,
      tracking: { feature: 'profile', $subFeature: 'popup-visitreferral' },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([ui.frame.image]);
  }

  public init({
    avatar,
    avatarFrame,
    playerName,
    title,
    message = `Let's tell your friend that you've revived their pet!`,
  }: {
    avatar: string;
    avatarFrame: AvatarFrameId;
    playerName: string;
    title: string;
    message: string;
  }) {
    super.init({
      title,
      message,
    });

    const { opts } = this;

    this.buttonClose.removeFromSuperview();

    const frame = new ImageScaleView({
      superview: this.box,
      ...ui.frame,
      width: this.box.style.width * 0.9,
      x: this.box.style.width / 2,
      y: 165,
    });

    const avatarImg = new Avatar({
      superview: frame,
      x: 85,
      y: frame.style.height * 0.5,
      width: 115,
      height: 115,
    });
    avatarImg.updateImage(avatar);
    avatarImg.setFrame(avatarFrame);

    new LangBitmapFontTextView({
      superview: frame,
      ...ui.playerName,
      height: frame.style.height,
      localeText: () => playerName ?? 'John Doe',
    });

    this.message.updateOpts({
      superview: this.box,
      ...ui.message,
      size: 30,
      x: this.box.style.width / 2,
      y: 315,
      width: this.box.style.width * 0.85,
      height: 96,
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.cancel,
      ...ui.button,
      superview: this.box,
      x: this.box.style.width / 4,
      y: this.box.style.height - 25 - 100 / 2,
      localeText: () => i18n('basic.cancel'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        return opts.close(false);
      },
      tracking: {
        feature: 'popup-confirmvisit',
        $subFeature: 'popup-confirmvisit-close',
      },
    });

    new ButtonScaleViewWithText({
      ...uiConfig.buttons.secondary,
      superview: this.box,
      ...ui.button,
      x: (this.box.style.width / 4) * 3,
      y: this.box.style.height - 25 - 100 / 2,
      localeText: () => i18n('friendsVisit.confirm.ok'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(true);
      },
      tracking: {
        feature: 'popup-confirmvisit',
        $subFeature: 'popup-confirmvisit-ok',
      },
    });
  }
}
